import HeartSVG from '../../assets/svg/heart.svg';
export default HeartSVG;
